module.exports = __webpack_public_path__ + "static/media/cover.7e703490.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/aida/cover.jpg
// module id = 53
// module chunks = 0